import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { unbem } from '~/layout/styleguide/utils/filters';
import { getOuterHTML } from '~/helpers/utils';
export default {
  name: 'sg-icon-grid',
  props: ['name'],

  data() {
    return {
      icons: []
    };
  },

  filters: {
    sanitize: function sanitize(value) {
      if (!value.includes('icon')) return value;
      return unbem(value).replace('icon', '').trim();
    }
  },
  methods: {
    getRegisteredIcons() {
      return this.$slots.register[0].children.map(child => {
        if (child.tag !== 'undefined' && child.tag === 'svg') {
          return {
            html: getOuterHTML(child.elm),
            title: child.data.staticClass.split(' ').pop()
          };
        }
      }).filter(Boolean);
    }

  },

  mounted() {
    this.icons = this.getRegisteredIcons();
  }

};